<template>
  <section class="help pt-16 px-md-14">
    <h2 class="mt-4 ml-4">{{ helpData.title }}</h2>
    <v-form v-model="isValidForm">
      <v-row no-gutters class="pt-4 pb-8">
        <v-col cols="12" class="col-sm-6 px-5">
          <p class="my-8">
            {{ helpData.description }}
          </p>
        </v-col>
        <v-col cols="12" class="col-sm-6">
          <div class="help__form px-5 py-8">
            <v-text-field
              class="text-field"
              v-model="name"
              :placeholder="helpData.fieldsPlaceholder.name"
              outlined
              dense
              clearable
              color="#FFA903"
              flat
              style="border-radius: 0 !important;"
              required
              :rules="nameRules"
            />
            <v-row class="mt-md-4 mt-0">
              <v-col cols="12" class="col-md-8">
                <v-text-field
                  class="text-field"
                  type="number"
                  v-model="amount"
                  :placeholder="helpData.fieldsPlaceholder.amount"
                  outlined
                  dense
                  clearable
                  color="#FFA903"
                  flat
                  style="border-radius: 0 !important;"
                  required
                  :rules="moneyRules"
                />
              </v-col>
              <v-col cols="auto">
                <v-btn
                  color="#FFA903"
                  class="main-btn text-capitalize"
                  width="100%"
                  height="40"
                  :disabled="!isValidForm"
                  @click="sendMoney"
                  :loading="loading"
                >
                  {{ helpData.buttonTitle }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </section>
</template>

<script>
import { postDonation } from "@/api/donation";

export default {
  name: "Help",
  computed: {
    helpData() {
      return this.$t("help");
    },
    errorMessages() {
      return this.$t("help").fieldsMessages;
    }
  },
  data() {
    return {
      name: "",
      amount: undefined,
      nameRules: [v => !!v || this.errorMessages.nameEmpty],
      moneyRules: [
        v => !!v || this.errorMessages.amountEmpty,
        v => v >= 500 || this.errorMessages.amountFailure
      ],
      isValidForm: false,
      loading: false
    };
  },
  methods: {
    async sendMoney() {
      this.loading = true;
      try {
        const response = await postDonation({
          name: this.name,
          amount: Number(this.amount)
        });
        if (response?.redirect_link) {
          window.location.href = response.redirect_link;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
@import "./src/assets/style/vars"

.help
  width: 100%
  min-height: calc(100vh - 100px)
  color: $dark
  &__form
    background: #F9F7FC
    input
      background: #FFFFFF
      opacity: 0.2
      border: 1px solid #2F2E43
      box-sizing: border-box
      border-radius: 0
      outline: none
      padding: 8px 0 8px 20px
      width: 100%
      color: #2F2E43 !important
      font-family: Roboto, sans-serif
      font-style: normal
      font-weight: normal
      font-size: 16px
      line-height: 24px
      transition: all .4s ease
      &:focus
        opacity: 1
      &::-webkit-outer-spin-button, &::-webkit-inner-spin-button
        -webkit-appearance: none
        margin: 0


small
  font-family: 'Inter', sans-serif
  font-size: 12px
  line-height: 20px
  display: flex
  align-items: center
  color: #EA0000
  margin-top: 5px
  transition: all .4s ease

.error-input
  border: 1px solid #EA0000 !important
  opacity: 1 !important
</style>
